// extracted by mini-css-extract-plugin
export default {"accordion":"accordion_accordion__S3pA3","accordionTrigger":"accordion_accordionTrigger__TAJk2","accordionTitle":"accordion_accordionTitle__aXdIr"};